import ApiService from 'config/apiServiceApiGateway'
import { SEODetailResponseType, SEOUpdatePayloadType, SEOUpdateResponseType } from '../@types/SEO'

export const getProductSEOApi = (productId: number) =>
  ApiService.Get<SEODetailResponseType>({
    url: '/wims/internal/v1/products/:productId/attributes/seo',
    urlParams: { productId },
  })

export const updateProductSEOApi = (productId: number, payload: SEOUpdatePayloadType) =>
  ApiService.Put<SEOUpdateResponseType, true>({
    url: '/wims/internal/v1/products/:productId/attributes/seo',
    urlParams: { productId },
    data: payload,
  })
